import { Component, Inject, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

// '../../input-models/imput-models.component.scss'

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  btnOneIcon:string,
  textBtnOne:string,
  textBtnTwo:string,
  textExtra:string,
  textLink:string,
  routerContentLink:string,
  infoBoxIcon:string,
  infoBoxSpan:string,
  infoBoxNumber:string,
}


@Component({
  selector: 'app-model-modal-two-button',
  templateUrl: './model-modal-two-button.component.html',
  styleUrls: ['./model-modal-two-button.component.scss']
})
export class ModelModalTwoButtonComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModelModalTwoButtonComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {}

}